import { tr } from "../../i18n";
export function validateOvertimeRules(rules) {
  const errors = [];

  // Normalize all rules into ranges
  const normalized = rules.map((r, index) => {
    if (r.type === "single") {
      return { index, type: "single", from: r.hour, to: r.hour };
    }
    return { index, type: "range", from: r.from, to: r.to };
  });

  // Sort by the start of the range
  normalized.sort((a, b) => a.from - b.from);

  // Check for overlap
  for (let i = 0; i < normalized.length - 1; i++) {
    const curr = normalized[i];
    const next = normalized[i + 1];

    if (curr.to >= next.from) {
      errors.push({
        indexes: [curr.index, next.index],
        message: tr("shared:range_from_to_overlaps_with_from2", { from: curr.from, to: curr.to, from2: next.from, to2: next.to }),
      });
    }
  }

  // Check logical errors
  normalized.forEach((r) => {
    if (r.from > r.to) {
      errors.push({
        indexes: [r.index],
        message: tr("shared:invalid_range_from_to_from_cannot", { from: r.from, to: r.to }),
      });
    }
  });

  return errors;
}
